import { Banner, Text } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../utilities/i18n";

export interface MatchingBaseProductBannerProps {}
export const MatchingBaseProductBanner =
  ({}: MatchingBaseProductBannerProps) => {
    const { t } = useTranslation("invoice_arrival");
    return (
      <Banner status="info" title={t("banner.base_product_found.title")}>
        <Text>{t("banner.base_product_found.description")}</Text>
      </Banner>
    );
  };
